angular.module('zc.projects')
  .controller('uniqueCouponCodeCSVUploadController', uniqueCouponCodeCSVUploadController);

uniqueCouponCodeCSVUploadController.$inject = ['$scope', '$state', '$translate', 'UniqueCouponCode'];
function uniqueCouponCodeCSVUploadController($scope, $state, $translate, UniqueCouponCode) {
  $scope.$on('flow::fileAdded', function(event, $flow, flowFile) {
    event.preventDefault();
    UniqueCouponCode.upload(
      {
        projectId: $state.params.projectId,
        incentiveId: $state.params.incentiveId
      },
      {
        file: flowFile.file
      })
      .then(res => {
        if(res.excluded.length > 0) {
          const excludedCodes = $translate.instant('projectsIncentives.controllers.uniqueCouponCodeCsvUpload.jogai_saretakuuponkoodo', {
            list: res.excluded.join(', ')
          });
          // eslint-disable-next-line no-undef
          alertify.error(excludedCodes, 0);
        }
        $state.reload();
      });
  });
}



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects.incentives/unique_coupon_code_csv_upload.controller.js